import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Termos = styled.a`
  color: ${colors.green};
  text-decoration: underline;
  cursor: pointer;
  margin: 4px;
`
